import { render } from "./DialogTemporaryBlocked.vue?vue&type=template&id=5332b939"
import script from "./DialogTemporaryBlocked.vue?vue&type=script&lang=js"
export * from "./DialogTemporaryBlocked.vue?vue&type=script&lang=js"
script.render = render

export default script